var _circle, _path, _path2, _path3, _path4, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfSigning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#AAF08C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C14 18.7909 15.7909 17 18 17H19C21.2091 17 23 18.7909 23 21V23H14V21Z",
    fill: "#e2d1fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H42C44.2091 17 46 18.7909 46 21V48H26C23.7909 48 22 46.2091 22 44V17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 43C50 45.2091 48.2091 47 46 47L29 47L29 41L50 41L50 43Z",
    fill: "#e2d1fa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0104 39.7H46.6458V21.8C46.6458 18.1 43.5781 15 39.9167 15H18.3438C15.375 15 13 17.4 13 20.4V23.3C13 23.9 13.3958 24.3 13.9896 24.3H21.6094V45.1C21.6094 47.3 23.3906 49 25.4688 49H45.6562C49.0208 49 51 46.3 51 43.6V40.7C51 40.2 50.5052 39.7 50.0104 39.7ZM14.9792 20.4C14.9792 18.5 16.4635 17 18.3438 17C20.224 17 21.7083 18.5 21.7083 20.4V22.3H14.9792V20.4ZM28.8333 40.7V43.6C28.8333 45 27.8438 47 25.4688 47C24.3802 47 23.5885 46.1 23.5885 45.1V23.3V20.4C23.5885 19.1 23.0938 18 22.401 17H39.9167C42.4896 17 44.6667 19.2 44.6667 21.8V39.7H29.8229C29.2292 39.7 28.8333 40.2 28.8333 40.7ZM49.0208 43.6C49.0208 45 48.0312 47 45.6562 47H29.625C30.4167 46 30.8125 44.8 30.8125 43.6V41.7H49.0208V43.6Z",
    fill: "#090927"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 22,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#090927"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31.4141,
    width: 2,
    height: 7,
    rx: 1,
    transform: "rotate(-45 29 31.4141)",
    fill: "#090927"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9492,
    y: 36.3638,
    width: 2,
    height: 7,
    rx: 1,
    transform: "rotate(-135 33.9492 36.3638)",
    fill: "#090927"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSigning);
export default __webpack_public_path__ + "static/media/self-signing.30830736f0b19b8a017db88e9b4db8f3.svg";
export { ForwardRef as ReactComponent };